import constants from 'constants/constants';
import { useQuery } from 'react-query';

import { QueryParams, ReportList, getReportList as queryFn } from 'api/endPoints/getReportList';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetReportList = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, ReportList[], [QueryKeys, unknown]>({
        queryKey: ['getReportList', params],
        queryFn: () => queryFn({ filter: params.filter }),
        select: (data) => data.reports,
        staleTime: constants.MINUTE * 5,
    });
};

export interface QueryResponse {
    reports: ReportList[];
}
